import { action, observable } from 'mobx'
import { CSSProperties, ReactNode } from 'react'

interface DialogServiceShowProps {
  title?: string | ReactNode
  content?: string | ReactNode
  actions?: null | ReactNode
  contentStyle?: CSSProperties
}

export class DialogService {
  @observable
  open = false
  title: DialogServiceShowProps['title']
  content: DialogServiceShowProps['content']
  actions: DialogServiceShowProps['actions']
  contentStyle?: CSSProperties

  @action
  show(props: DialogServiceShowProps) {
    this.title = props.title
    this.content = props.content
    this.actions = props.actions
    this.contentStyle = props.contentStyle
    this.open = true
  }

  @action
  hide = () => {
    this.open = false
    this.title = ''
    this.content = ''
    this.actions = null
    this.contentStyle = {}
  }
}
